import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { IdentityStorage } from "../../_models/identity.storage";

import { LocalStorageService } from "angular-web-storage";
import { environment } from "src/environments/environment";
import { AuthenticationExternoResponse } from "../../_models/authentication-externo-response";
import { AuthenticationResult } from "../../_models/authentication-result";
import { Authenticator } from "./interface/authenticator";


export class AutenticacaoAdvogado implements Authenticator {
    private readonly baseUrl = environment.url;
    private messageSource = new BehaviorSubject(false);
    public message = this.messageSource.asObservable();

    constructor(private http: HttpClient, private identityStorage: IdentityStorage, public local: LocalStorageService) { }

    authenticate(login: string, password: string): Observable<AuthenticationResult> {
        const loginForm = { login: login, password: password };

        return this.http.post<AuthenticationExternoResponse>(this.baseUrl + 'login-externo/', loginForm)
            .map(resp => {
                if (resp.token) {
                    const token = resp.token;
                    const id = resp.id;
                    const userName = resp.nome;
                    const perfil = 'ADVOGADO';
                    const resetPassword = resp.redefinirSenha;                    
                    this.local.set('idUsuario', id);
                    if (token) {
                        const userAuthData = {
                            token: token,
                            userName: userName,
                            id: id,
                            perfil: perfil,
                            resetPassword: resetPassword
                        };
                        this.identityStorage.saveAuthData(userAuthData);
                        this.messageSource.next(true);

                        return new AuthenticationResult(true, null);
                    }
                } else {
                    this.messageSource.next(false);
                    return new AuthenticationResult(false, 'Login ou Senha Inválidos');
                }
            });
    }


}

